<template>
  <div class="index row-me">
    <!--左侧布局-->
    <div class="left-div" :class="{ 'left-div-close': !isOpened }">
      <div class="posAbsoluteAll column-me row-center">
        <img src="../assets/images/logo.png" class="img-logo" draggable="false" v-if="isOpened"/>
        <img src="../assets/images/logo_min.png" class="img-logo1" draggable="false" v-else/>
        <div class="menu-div flex1 column-me" v-dragscroll.y="true">
          <div class="width100Per">
            <el-menu
                background-color="#050c5b"
                :collapse="!isOpened"
                :default-active="defaultActive"
            >
              <div v-for="(item,index) in menuArray" :key="index">
                <el-sub-menu :index="index+''" v-if="item.children.length>0">
                  <template #title>
                    <img :src="item.icon" class="menu-icon">
                    <span v-if="isOpened">{{ item.name }}</span>
                  </template>
                  <el-menu-item :index="index+'-'+index1" v-for="(item1,index1) in item.children" :key="index1"
                                @click="clickMenu(item1.url)">
                    {{ item1.name }}
                  </el-menu-item>
                </el-sub-menu>
                <el-menu-item :index="index+''" @click="clickMenu(item.url)" v-else>
                  <img :src="item.icon" class="menu-icon">
                  <template #title>{{ item.name }}</template>
                </el-menu-item>
              </div>
            </el-menu>
          </div>
        </div>
      </div>
    </div>

    <!--右侧布局-->
    <div class="right-div column-me flex1" style="overflow: auto">
      <div class="top-div row-me row-center">
        <img src="../assets/img/menu.png" class="margin-left20 pointer" title="合上" @click="clickClose"
             v-if="isOpened"/>
        <img src="../assets/img/menu1.png" class="margin-left20 pointer" title="展开" @click="clickClose"
             v-else/>
        <div class="flex1"></div>
        <el-image :src="user.headImage" :preview-src-list="[user.headImage]" fit="cover" class="img-header">
          <template #error>
            <img src="../assets/img/mrtx.png" slot="error"
                 class="width100Per height100Per objFitCover"/>
          </template>
        </el-image>
        <div class="title1 margin-left10 margin-right20" v-if="user">
          {{ user.real_name ? user.real_name : '游客' }}
        </div>
        <div class="line-shu"></div>
        <div class="row-me row-center margin-left20 pointer" @click="clickExit">
          <img src="../assets/img/exit.png" title="退出登录" class="img-icon"/>
          <div class="title1 margin-left5 margin-right20" v-if="user">退出</div>
        </div>
      </div>
      <div class="row-me width100Per flex1" style="overflow: auto;">
        <div class="main-content flex1">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      isOpened: true, //菜单展开
      menuArray: [], //左侧菜单
      user: {}, //当前登录用户
      defaultActive: '0-0',//默认活跃的菜单
    };
  },
  // html加载完成之前
  created() {
    let that = this
    setTimeout(() => {
      let token = sessionStorage.getItem('token');
	  let acctype = sessionStorage.getItem('acctype')
      if (this.$method.isEmpty(token)) {
		  if(acctype === 3){
			  that.$router.replace({
			    path: '/angetlogin'
			  })
		  }else{
			  that.$router.replace({
			    path: '/login'
			  })
		  }
        return
      }
      let user = JSON.parse(sessionStorage.getItem('user'))
      if (this.$method.isEmpty(user)) {
        that.$router.replace({
          path: '/login'
        })
      }
    }, 1000)
    let menuOpen = localStorage.getItem("menuOpen");
    this.isOpened = menuOpen === null || menuOpen === true || menuOpen === "true";
    this.getMenu()
  },
  // html加载完成后执行。
  mounted() {
	//获取用户信息
    let user = JSON.parse(sessionStorage.getItem('user'))
    if (user && user !== '') {
      this.user = user
    }
  },
  // 事件方法执行
  methods: {
    //获取菜单
    getMenu() {
      this.$post('/admin/systemMenuList', {}).then((res) => {
        if (res) {
          for (let item of res.data) {
            item.icon = require('../assets/images/' + item.icon)
          }
          this.menuArray = res.data
          this.initMenu()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //初始化选中菜单
    initMenu() {
      let parentPath = '';
      let path = this.$route.path;//如："/aaa/bbb"
      let arr = path.split('/')//获取父级路径，防止有详情等多级页面
      for (const item of arr) {
        if (!this.$method.isEmpty(item)) {
          parentPath = '/' + item;//父级路径，如："/aaa"
          break;
        }
      }
      for (let i = 0; i < this.menuArray.length; i++) {
        let menu = this.menuArray[i]
        if (menu.children.length > 0) {//有二级菜单
          for (let j = 0; j < menu.children.length; j++) {
            let child = menu.children[j]
            if (parentPath === '/' || parentPath === '') {//跳转第一个二级菜单
              if (i === 0 && j === 0) {
                this.clickMenu(child.url)
              }
            } else {
              if (child.url === parentPath) {
                this.defaultActive = i + '-' + j
              }
            }
          }
        } else {//无二级菜单
          if (parentPath === '/' || parentPath === '') {//跳转第一个菜单
            this.clickMenu(menu.url)
          } else {
            if (menu.url === parentPath) {
              this.defaultActive = i + ''
            }
          }
        }
      }
    },
    //菜单点击
    clickMenu(e) {
      this.$router.push({
        path: e,
        query: {}
      })
    },
    //退出登录
    clickExit() {
		this.$confirm('您确定要退出登录吗？', '温馨提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			const acctype = sessionStorage.getItem('acctype');
			console.log(acctype);
			if(acctype == 3){
				this.$router.replace({
					path: '/agentLogin',
					query: {}
				});
			}else{
				this.$router.replace({
					path: '/login',
					query: {}
				});
			}
			sessionStorage.removeItem('user');
			sessionStorage.removeItem('acctype');
			sessionStorage.removeItem('token');
		}).catch(() => {

		});
    },
    //菜单展开合并
    clickClose() {
      this.isOpened = !this.isOpened;
      localStorage.setItem("menuOpen", this.isOpened);
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    $route: {
      handler(newVal, oldVal) {

      },
      deep: true
    }
  },
}
</script>

<style lang="scss" scoped>
.index {
  width: 100vw;
  height: 100vh;
  font-size: 18px;
  color: #222222;

  .left-div {
    width: 200px;
    height: 100%;
    background-color: #122a8a;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    transition: 0.3s;

    &-close {
      width: 80px;
    }

    .menu-icon {
      width: 22px;
      height: 22px;
      object-fit: scale-down;
      margin-right: 10px;
      display: inline;
    }

    .img-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .img-logo {
      width: 70%;
      margin-top: 6%;
      object-fit: scale-down;
    }

    .img-logo1 {
      width: 62%;
      margin-top: 6px;
      object-fit: scale-down;
    }

    .img-logo-text {
      width: 120px;
      height: 30px;
      object-fit: scale-down;
      margin-top: 10px;
    }

    .img-hong {
      width: 140px;
      height: 165px;
      object-fit: scale-down;
      user-select: none;
      pointer-events: none;
    }

    .menu-div {
      width: 100%;
      margin-top: 12px;
      overflow: auto;
      align-items: flex-end;
      /* Firefox */
      scrollbar-width: none;
      /* IE 10+ */
      -ms-overflow-style: none;
      padding-bottom: 30px;

      /* Chrome Safari */
      &::-webkit-scrollbar {
        display: none;
      }

      .item-menu {
        width: 100%;
        height: 120px;
        cursor: pointer;

        &-active {
          background: #154C93;
        }

        &:hover {
          background: #154C93;
        }

        .img-menu {
          width: 30px;
          height: 30px;
          object-fit: scale-down;
        }

        .menu-text {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.5);
          word-break: keep-all;
          text-overflow: ellipsis;
          margin-top: 10px;

          &-active {
            color: #FFFFFF;
          }
        }
      }
    }
  }

  .right-div {
    height: 100%;

    .top-div {
      width: 100%;
      height: 66px;
      background-color: #050c5b;
      background-size: 100%;

      .img-header {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }

      .title1 {
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        color: #ffffff;
      }

      .line-shu {
        width: 1px;
        height: 24px;
        background: #ECECEC;
      }

      .title {
        font-size: 20px;
        color: #222222;
      }

      .img-icon {
        width: 30px;
        height: 30px;
        object-fit: scale-down;
      }
    }

    .second-menu-div {
      width: 160px;
      // width: 0;
      height: 100%;
      background: #ffffff;
      box-shadow: 5px 5px 10px #ccc;
      z-index: 10;
      overflow: auto;
      // animation: openMenu 0.2s 1 ease-out;
      transition: 0.3s;
      /* Firefox */
      scrollbar-width: none;
      /* IE 10+ */
      -ms-overflow-style: none;

      /* Chrome Safari */
      &::-webkit-scrollbar {
        display: none;
      }

      &-open {
        width: 160px;
      }

      .item-menu-two {
        height: 60px;
        line-height: 60px;
        text-align: left;
        padding-left: 20px;
        font-size: 18px;
        color: #666666;
        cursor: pointer;
        word-break: keep-all;
        text-overflow: ellipsis;

        &-active {
          background: #E8EEF9;
          font-weight: bold;
          color: #DBB081;
        }

        &:hover {
          background: #E8EEF9;
        }
      }
    }

    @keyframes openMenu {
      0% {
        width: 0;
      }

      100% {
        width: 160px;
      }
    }

    .main-content {
      font-size: 18px;
      color: #252630;
      background: #F6F9FC;
      height: 100%;
      overflow: auto;
    }
  }
}

.user-info-text {
  color: #000000;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    font-weight: bold;
  }
}
</style>
